import { render } from "./KeyFeaturesPanel.vue?vue&type=template&id=0a7f1c00&scoped=true"
import script from "./KeyFeaturesPanel.vue?vue&type=script&lang=js"
export * from "./KeyFeaturesPanel.vue?vue&type=script&lang=js"

import "./KeyFeaturesPanel.vue?vue&type=style&index=0&id=0a7f1c00&scoped=true&lang=css"

import exportComponent from "/vercel/path0/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a7f1c00"]])

export default __exports__